import { SelectFilter } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  value: string
  updateFilterState: (value: Record<string, string>) => void
}

export const MatchesSignFilter: FC<Props> = ({ value, updateFilterState }) => {
  const { t } = useTranslation('dashboard')

  const options = [{ label: t('shippedDeals'), value: 'true' }]

  return (
    <SelectFilter
      placeholder={t('sign')}
      options={options}
      onChange={(has_shipped_deals) => updateFilterState({ has_shipped_deals })}
      value={value}
      showSearch={false}
    />
  )
}
